<div class="row" [class]="class" *ngIf="additionalFiles.length">
  <div class="col-md-12 form-group">
    <label>{{'Additional Document' | translate}}</label>
      <div class="row ad-file" *ngFor="let doc of additionalFiles" (click)="viewFile(doc)">
        <div class="col-6 ad-file__name">
          <span>{{doc.name}}</span>
        </div>
        <div class="col-6 ad-file__reason">{{doc.added_reason}}</div>
      </div>
  </div>
</div>
